import { getHelpCategory }  from '@/api/help-center'

interface IState {
  helpCategory: IHelpCategory[]
}
const state:IState = {
  helpCategory: []
}

export default {
  state,
  mutations: {
    setHelpCategory(state: any, categorys: IHelpCategory[]) {
      state.helpCategory = categorys
    }
  },
  actions: {
    
    async setHelpCategorys(state, e) {
      console.log(state, e)
      const categorys: IHelpCategory[] = await getHelpCategory(e)

      state.commit('setHelpCategory', categorys)

      return categorys
    }
  }
}